module.exports = __webpack_public_path__ + "c50f46d1e4ba0a7f374c7fa2a82bbf15.svg";